import type { TrackingFn } from '@change-corgi/core-react/tracking';

function getTrackingCommonData() {
	return {
		location: 'tiktok',
	};
}

export function trackShare(
	eventName: string | undefined,
	trackingData: Record<string, string | number | boolean | undefined> | undefined,
	track: TrackingFn,
): void {
	if (!eventName) return;
	void track(eventName, { ...getTrackingCommonData(), ...trackingData });
}

export function trackShareFailure(
	eventName: string | undefined,
	trackingData: Record<string, string | number | boolean | undefined> | undefined,
	track: TrackingFn,
): void {
	if (!eventName) return;
	void track(eventName, { ...getTrackingCommonData(), ...trackingData });
}
